const getOrganizationLicenses = state => state.licenses
const getOrganizationId = state => state.id
const getOrganizationName = state => state.name
const getOrganizationSupportEmail = state => state.supportEmail
const getOrganizationPhoneNumber = state => state.phoneNumber
const getOrganizationTimeZone = state => state.timeZone

export default {
    getOrganizationLicenses,
    getOrganizationId,
    getOrganizationName,
    getOrganizationSupportEmail,
    getOrganizationPhoneNumber,
    getOrganizationTimeZone
}
